import { FC } from 'react';
import { StatsModal } from '../StatsModal';
import type { useMessagesGQL } from '../../../../hooks/graphql/dashboard/useMessagesGQL';
import { buildEmailColumns } from './emailColumns';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  dateRange: { from: Date | null; to: Date | null };
  onDateRangeChange?: (range: { from: Date | null; to: Date | null }) => void;
  timezone?: string;
  emailsGQL: ReturnType<typeof useMessagesGQL>;
  onOpenContact: (contactId: string) => void;
}

/**
 * Email Opens drill-down (the "Emails" tile on the dashboard). Lists
 * outbound messages with a clickable subject that opens the email
 * preview modal.
 */
export const EmailsStatsModal: FC<Props> = ({
  isOpen,
  onClose,
  dateRange,
  onDateRangeChange,
  timezone,
  emailsGQL,
  onOpenContact,
}) => {
  if (!isOpen) return null;
  return (
    <StatsModal
      isOpen={isOpen}
      onClose={() => {
        onClose();
        emailsGQL.setSearch?.(undefined);
      }}
      title="Emails"
      dateRange={dateRange}
      onDateRangeChange={onDateRangeChange}
      onSearch={(q) => emailsGQL.setSearch?.(q || undefined)}
      searchPlaceholder="Search by name or subject..."
      currentPage={emailsGQL.currentPage}
      pageSize={emailsGQL.pageSize}
      onNextPage={emailsGQL.nextPage}
      onPrevPage={emailsGQL.prevPage}
      onPageChange={emailsGQL.goToPage}
      onPageSizeChange={emailsGQL.changePageSize}
      totalCount={emailsGQL.total}
      isLoading={emailsGQL.isLoading}
      columns={buildEmailColumns({ timezone, onOpenContact })}
      data={emailsGQL.items || []}
    />
  );
};

export default EmailsStatsModal;
